import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { NEWS_API } from "./apiRoutes";

const mutateAddLatestNews = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${NEWS_API}/`, data);
};

const useAddLatestNewsMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddLatestNews,
    ...queryParams,
  });

export default useAddLatestNewsMutation;
